<template>

<div>
  <PageTitle :route="$route">
    <!-- <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template> -->
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <FrotaHelperList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import FrotaHelperList from '@/components/settings/frota/helper/FrotaHelperList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'FrotaHelper',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    FrotaHelperList
  },
  // methods: {
  //   onClickButton (e) {
  //     this.$router.push({ name: 'addfrotahelper' })
  //   }
  // }
}
</script>
